import { BouColor } from '@upright/ui/common/generic/global/bou-colors';

// Lifted here to avoid circular imports

export const borderCSS = `1px solid ${BouColor.TOOL_BORDER_LIGHTER_GRAY};`;
export const borderRadiusCSS = `10px`;
